module.exports = __webpack_public_path__ + "static/media/tt_norms_regular.3f4e79d5.otf";